import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { PersonIcon, Ton3dIcon } from "@/assets"
import { useMatchSearch } from "@/hooks/useMatchSearch"
import { useMoneyEnough } from "@/hooks/useMoneyEnough/useMoneyEnough.ts"
import { useModals } from "@/modals"
import { useAppSelector } from "@/store"
import {
  IMatchBidVariant,
  useGetMatchRoomPlayersCountQuery
} from "@/store/apis/matchAPI"
import { FindMatchSelectors } from "@/store/slices/findMatch"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import styles from "./TonRoom.module.scss"

interface ITonRoom extends IMatchBidVariant {}

export const TonRoom: FC<ITonRoom> = ({
  _id,
  buyInValue,
  buyInCurrency,
  imgSrc
}) => {
  const { t } = useTranslation()
  const { closeModal } = useModals()
  const { handleSearchMatch, isLoading } = useMatchSearch()
  const isMoneyEnough = useMoneyEnough(buyInValue, buyInCurrency)

  const isSearching = useAppSelector(
    FindMatchSelectors.selectFindMatchIsSearching()
  )

  const { data: roomPlayersCountData } = useGetMatchRoomPlayersCountQuery()
  const roomPlayersCount = roomPlayersCountData?.counts[_id] || 0

  const handleSearch = async () => {
    try {
      await handleSearchMatch(_id)
      closeModal("tonRooms")
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Container className={clsx(styles.TonRoom)}>
      <Container className={clsx(styles.TonRoom_imgBox)}>
        <div className={clsx(styles.TonRoom_amount)}>
          <Ton3dIcon /> x {buyInValue}
        </div>
        <div className={clsx(styles.TonRoom_img)}>
          <img src={imgSrc} alt={"room-icon"} />
        </div>
      </Container>
      <div className={clsx(styles.TonRoom_players)}>
        <div className={clsx(styles.TonRoom_players_count)}>
          <PersonIcon />
          {roomPlayersCount}/2
        </div>
        <div className={clsx(styles.TonRoom_players_text)}>
          {t("playForTon.room.wait")}
        </div>
      </div>
      <Button
        className={clsx(styles.TonRoom_button)}
        disabled={!isMoneyEnough || isSearching}
        isLoading={isLoading}
        onClick={handleSearch}
      >
        {t("button.join")}
      </Button>
    </Container>
  )
}
